import React, { Component } from "react";
import ReactGA from "react-ga";
import "./App.css";
import "./Lobby.css";
import "./fonts.css";
import CustomAlert from "./custom-alert/CustomAlert";
import RoleAlert from "./custom-alert/RoleAlert";
import EventBar from "./event-bar/EventBar";

// TODO: replace constants with enums from types
import {
  PAGE,
  MAX_FAILED_CONNECTIONS,
  SERVER_ADDRESS_HTTP,
  NEW_LOBBY,
  CHECK_LOGIN,
  SERVER_ADDRESS,
  WEBSOCKET,
  PARAM_USERNAMES,
  LOBBY_CODE_LENGTH,
  PARAM_STATE,
  STATE_CHANCELLOR_NOMINATION,
  STATE_CHANCELLOR_VOTING,
  PARAM_PRESIDENT,
  STATE_LEGISLATIVE_PRESIDENT,
  STATE_LEGISLATIVE_CHANCELLOR,
  PARAM_PACKET_TYPE,
  PACKET_LOBBY,
  PACKET_GAME_STATE,
  PACKET_INVESTIGATION,
  PACKET_OK,
  PACKET_ERROR,
  STATE_SETUP,
  STATE_POST_LEGISLATIVE,
  STATE_LEGISLATIVE_PRESIDENT_VETO,
  STATE_PP_INVESTIGATE,
  STATE_PP_EXECUTION,
  STATE_PP_ELECTION,
  STATE_PP_PEEK,
  PLAYER_IS_ALIVE,
  PARAM_TARGET,
  STATE_FASCIST_VICTORY_ELECTION,
  STATE_FASCIST_VICTORY_POLICY,
  STATE_LIBERAL_VICTORY_EXECUTION,
  STATE_LIBERAL_VICTORY_POLICY,
  WEBSOCKET_HEADER,
  DEBUG,
  PACKET_PONG,
  PING_INTERVAL,
  SERVER_PING,
  PARAM_ICON,
  PARAM_INVESTIGATION,
  RECONNECT_DELAYS_MS,
  PONG_TIMEOUT_MS,
  CLOSE_REPLACED,
  CLOSE_LEFT,
  CLOSE_KICKED,
  TOKEN_STORAGE_KEY,
} from "./constants";

import PlayerDisplay from "./player/PlayerDisplay";
import HitlerZoneVignette from "./effects/HitlerZoneVignette";
import { isSoundEnabled, playSound, setSoundEnabled, SoundName } from "./effects/sound";
import "./effects/effects.css";
import "@fontsource/germania-one/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "./game-ui/theme.css";
import PolicyTrack from "./game-ui/PolicyTrack";
import PlayerCards, { roundSeatPosition } from "./game-ui/PlayerCards";
import ActionPanel, { MainPanel } from "./game-ui/ActionPanel";
import "./game-ui/RoundTable.css";
import IconDrawer from "./game-ui/IconDrawer";
import StartPage from "./game-ui/StartPage";
import ThemePicker from "./game-ui/ThemePicker";
import ThemeMenu from "./game-ui/ThemeMenu";
import LayoutMenu from "./game-ui/LayoutMenu";
import GameOverScreen from "./game-ui/GameOverScreen";
import VoteHistoryDialog, { hasVoteHistory } from "./game-ui/VoteHistory";
import RulesSheet from "./game-ui/RulesSheet";
import TipsPanel, { readTipsOpen, writeTipsOpen } from "./game-ui/TipsPanel";
import ExecutionDrama from "./game-ui/ExecutionDrama";
import { pendingAction, TurnAlert } from "./turnAlert";
import { KickConfirm, KickPicker } from "./game-ui/KickDialog";
import portraits from "./assets";
import { lastGovernmentSentence } from "./game-ui/history";
import DeckPiles, { Pile } from "./game-ui/DeckPiles";
import { isVictoryState } from "./utils";
import HitlerZoneWarning from "./effects/HitlerZoneWarning";
import VotingPrompt from "./custom-alert/VotingPrompt";
import PresidentLegislativePrompt from "./custom-alert/PresidentLegislativePrompt";
import ChancellorLegislativePrompt from "./custom-alert/ChancellorLegislativePrompt";
import VetoPrompt from "./custom-alert/VetoPrompt";
import ElectionTrackerAlert from "./custom-alert/ElectionTrackerAlert";
import PolicyEnactedAlert from "./custom-alert/PolicyEnactedAlert";
import {
  SelectExecutionPrompt,
  SelectInvestigationPrompt,
  SelectNominationPrompt,
  SelectSpecialElectionPrompt,
} from "./custom-alert/SelectPlayerPrompt";
import ButtonPrompt from "./custom-alert/ButtonPrompt";
import PeekPrompt from "./custom-alert/PeekPrompt";
import InvestigationAlert from "./custom-alert/InvestigationAlert";

import HelmetMetaData from "./util/HelmetMetaData";
import { isRoundTable, lobbyLink, setRoundTable } from "./variant";
import { defaultPortrait } from "./assets";
import { redeemSecretCode, SECRET_CODE_PATTERN } from "./secretIcons";
import Player from "./player/Player";
import Cookies from "js-cookie";
import {
  GameState,
  LobbyState,
  PolicyType,
  Role,
  ServerRequestPayload,
  WSCommand,
  WSCommandType,
} from "./types";

const EVENT_BAR_FADE_OUT_DURATION = 500;
const CUSTOM_ALERT_FADE_DURATION = 1000;

const DEFAULT_GAME_STATE: GameState = {
  liberalPolicies: 0,
  fascistPolicies: 0,
  discardSize: 0,
  drawSize: 17,
  players: {},
  playerOrder: [],
  state: LobbyState.SETUP,
  president: "",
  chancellor: "",
  electionTracker: 0,
  vetoOccurred: false,
  lastState: LobbyState.SETUP,
  lastChancellor: "",
  lastPresident: "",
  electionTrackerAdvanced: false,
  userVotes: {},
  presidentChoices: [],
  chancellorChoices: [],
  targetUser: "",
  lastPolicy: "",
  peek: [],
  icon: {},
};

const COOKIE_NAME = "name";
const COOKIE_LOBBY = "lobby";

/**
 * A random id for this browser, sent with every connection. It lets the server see that a new connection is the
 * same player as an older one (a phone that suspended the page, a network switch), so the player gets their seat
 * back at once instead of being turned away as a duplicate name. It is kept in localStorage so that it survives
 * a reload; without storage it lasts until the page is closed.
 */
function createConnectionToken(): string {
  try {
    const stored = window.localStorage.getItem(TOKEN_STORAGE_KEY);
    if (stored) {
      return stored;
    }
  } catch (e) {
    // Storage can be blocked (private mode); fall through and use a token for this page only.
  }
  let token: string;
  if (window.crypto && window.crypto.getRandomValues) {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    token = Array.from(bytes, (b) => ("0" + b.toString(16)).slice(-2)).join("");
  } else {
    token = Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
  try {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch (e) {
    // Ignore: see above.
  }
  return token;
}
const CONNECTION_TOKEN = createConnectionToken();

if (DEBUG) {
  console.warn("Running in debug mode.");
}

// TODO: Turn App into a functional component
// TODO: Refactor out pages into separate components
// TODO: Refactor out AnimationQueue

// TODO: Remove this type and replace with actual state variables.
type AppState = {
  page: PAGE;
  joinName: string;
  joinLobby: string;
  joinError: string;
  createLobbyName: string;
  createLobbyError: string;
  name: string;
  lobby: string;
  lobbyFromURL: boolean;
  usernames: string[];
  icons: { [key: string]: string };
  /* Players who pressed "ready" in the lobby, and players who lost their connection and hold a seat. */
  ready: string[];
  away: string[];
  /* Bot options chosen in the lobby: fill the game up to this many players, and seconds between bot actions. */
  botTarget: number;
  /* Test mode (every role visible) chosen by the host; only takes effect when playing alone with bots. */
  testMode: boolean;
  /** Whether the vote history window is open. */
  showVoteHistory: boolean;
  /** Whether the rules reminder window is open. */
  showRules: boolean;
  /** The tips sidebar is open (remembered in the browser; closed for new players). */
  showTips: boolean;
  /** The host is picking a player to remove during a game. */
  showKickList: boolean;
  /** The player the host is asked to confirm removing. */
  kickTarget?: string;
  gameState: GameState;
  /* Stores the last gameState[PARAM_STATE] value to check for changes. */
  lastState: any;
  liberalPolicies: number;
  fascistPolicies: number;
  /*The position of the election tracker, ranging from 0 to 3.*/
  electionTracker: number;
  showVotes: boolean;
  /** The votes being revealed (they come with the new game state, which is not shown on the board yet). */
  revealedVotes?: Record<string, boolean>;
  /**
   * The game state as the board shows it. It trails {@code gameState} while animations are playing, so that
   * the board never gives away a result (who won the vote, which policy was enacted) before the animation.
   */
  shownState: GameState;
  snackbarMessage: string;
  showAlert: boolean;
  alertContent: JSX.Element;
  showEventBar: boolean;
  eventBarMessage: string;
  statusBarText: string;
  allAnimationsFinished: boolean;
  /** The look picker drawer in the lobby. */
  iconDrawerOpen: boolean;
  /** Final game state shown on the game-over screen (set once the end-of-game animations have played). */
  gameOverState?: GameState;
};

const defaultAppState: AppState = {
  page: PAGE.LOGIN,
  joinName: "",
  joinLobby: "",
  joinError: "",
  createLobbyName: "",
  createLobbyError: "",
  name: "P1",
  lobby: "AAAAAA",
  lobbyFromURL: false,
  usernames: [],
  icons: {},
  ready: [],
  away: [],
  botTarget: 5,
  testMode: false,
  showVoteHistory: false,
  showRules: false,
  showTips: readTipsOpen(),
  showKickList: false,
  kickTarget: undefined,
  gameState: DEFAULT_GAME_STATE,
  lastState: {},
  liberalPolicies: 0,
  fascistPolicies: 0,
  electionTracker: 0,
  showVotes: false,
  revealedVotes: undefined,
  shownState: DEFAULT_GAME_STATE,
  snackbarMessage: "",
  showAlert: false,
  alertContent: <div />,
  showEventBar: false,
  eventBarMessage: "",
  statusBarText: "---",
  allAnimationsFinished: true,
  iconDrawerOpen: false,
};

/** How long (seconds) a bot waits before each action. */
const BOT_DELAY_IN_SEC = 0.5;

/** How long (ms) an alert stays up for an executed player before it closes by itself. */
const EXECUTED_ALERT_DURATION = 4500;

class App extends Component<{}, AppState> {
  websocket?: WebSocket = undefined;
  /** Connection attempts in a row that did not get an answer from the server. */
  failedConnections: number = 0;
  pingInterval?: NodeJS.Timeout = undefined;
  /** Waits for the next connection attempt after the connection dropped. */
  reconnectTimer?: NodeJS.Timeout = undefined;
  /** Fires when the server did not answer a ping that checked a connection that may have died silently. */
  pongTimer?: NodeJS.Timeout = undefined;
  /** When the last message arrived from the server (any message, including the answer to a ping). */
  lastMessageAt: number = 0;
  /** Whether the server has answered since the player logged in (a rejected login should not retry for long). */
  everConnected: boolean = false;
  reconnectOnConnectionClosed: boolean = true;
  snackbarMessages: number = 0;
  animationQueue: (() => void)[] = [];
  okMessageListeners: (() => void)[] = [];
  allAnimationsFinished: boolean = true;
  gameOver: boolean = false;
  /** Whether this player has been executed. They have no decisions left to make, so alerts close by themselves. */
  userIsExecuted: boolean = false;
  /** True while a Hitler / not Hitler reveal is on the screen: nothing else may close it or move the game on. */
  revealActive: boolean = false;

  // noinspection DuplicatedCode
  constructor(props: any) {
    super(props);

    let name = Cookies.get(COOKIE_NAME) ? Cookies.get(COOKIE_NAME) : "";
    let lobby = Cookies.get(COOKIE_LOBBY) ? Cookies.get(COOKIE_LOBBY) : "";

    this.state = {
      ...defaultAppState,
      joinName: name || "",
      joinLobby: lobby || "",
      createLobbyName: name || "",
    };

    // The website uses Google Analytics!
    ReactGA.initialize("UA-166327773-1");
    ReactGA.pageview("/");

    // These are necessary for handling class fields safely (ex: websocket)
    this.onWebSocketClose = this.onWebSocketClose.bind(this);
    this.tryOpenWebSocket = this.tryOpenWebSocket.bind(this);
    this.onClickLeaveLobby = this.onClickLeaveLobby.bind(this);
    this.onClickCopy = this.onClickCopy.bind(this);
    this.onClickStartGame = this.onClickStartGame.bind(this);
    this.sendWSCommand = this.sendWSCommand.bind(this);
    this.showSnackBar = this.showSnackBar.bind(this);
    this.onAnimationFinish = this.onAnimationFinish.bind(this);
    this.onGameStateChanged = this.onGameStateChanged.bind(this);
    this.hideAlertAndFinish = this.hideAlertAndFinish.bind(this);
    this.addAnimationToQueue = this.addAnimationToQueue.bind(this);
    this.clearAnimationQueue = this.clearAnimationQueue.bind(this);
    this.queueAlert = this.queueAlert.bind(this);
    this.onClickChangeIcon = this.onClickChangeIcon.bind(this);

    // Ping the server to wake it up if it's not currently being used
    // This reduces the delay users experience when starting lobbies
    fetch(SERVER_ADDRESS_HTTP + SERVER_PING);
  }

  /** Flashes the tab title and repeats the chime while the player has to act and is not looking at the game. */
  turnAlert = new TurnAlert(() => playSound("yourTurn"));

  componentDidUpdate() {
    const inGame = this.state.page === PAGE.GAME && !this.state.gameOverState;
    this.turnAlert.update(inGame ? pendingAction(this.state.gameState, this.state.name) : undefined);
  }

  componentDidMount() {
    // When the player comes back to the page (switching apps or tabs, waking the phone, regaining the network)
    // the connection has often died without the page noticing, because browsers suspend background pages.
    // Check it at once instead of waiting for the next ping.
    document.addEventListener("visibilitychange", this.onPageResumed);
    window.addEventListener("focus", this.onPageResumed);
    window.addEventListener("pageshow", this.onPageResumed);
    window.addEventListener("online", this.onPageResumed);
  }

  componentWillUnmount() {
    this.turnAlert.stop();
    document.removeEventListener("visibilitychange", this.onPageResumed);
    window.removeEventListener("focus", this.onPageResumed);
    window.removeEventListener("pageshow", this.onPageResumed);
    window.removeEventListener("online", this.onPageResumed);
    this.stopHeartbeat();
    this.clearReconnectTimer();
  }

  /////////// Server Communication
  // <editor-fold desc="Server Communication">

  /**
   * Attempts to request the server to create a new lobby and returns the response.
   * @return {Promise<Response>}
   */
  async tryCreateLobby() {
    return fetch(SERVER_ADDRESS_HTTP + NEW_LOBBY);
  }

  /**
   * Checks if the login is valid.
   * @param name the name of the user.
   * @param lobby the lobby code.
   * @return {Promise<Response>} The response from the server.
   */
  async tryLogin(name: string, lobby: string) {
    ReactGA.event({
      category: "Login Attempt",
      action: "User attempted to provide login credentials to the server.",
    });
    return await fetch(
      SERVER_ADDRESS_HTTP +
        CHECK_LOGIN +
        "?name=" +
        encodeURI(name) +
        "&lobby=" +
        encodeURI(lobby) +
        "&token=" +
        encodeURIComponent(CONNECTION_TOKEN)
    );
  }

  /**
   * Attempts to open a WebSocket with the server.
   * @param name the name of the user to connect with.
   * @param lobby the lobby to connect with.
   * @effects If a connection was successfully established, sets the state with the {@code name}, {@code lobby},
   *          and {@code ws} parameters. The WebSocket has a message callback to this.onWebSocketMessage().
   *          Any earlier connection is closed (without reconnecting) and any waiting retry is cancelled.
   * @return {boolean} true if the connection was opened successfully. Otherwise, returns false.
   */
  tryOpenWebSocket(name: string, lobby: string) {
    if (DEBUG) {
      console.log("Opening connection with lobby: " + lobby);
      console.log("Failed connections: " + this.failedConnections);
    }
    let url =
      WEBSOCKET_HEADER +
      SERVER_ADDRESS +
      WEBSOCKET +
      "?name=" +
      encodeURIComponent(name) +
      "&lobby=" +
      encodeURIComponent(lobby) +
      "&token=" +
      encodeURIComponent(CONNECTION_TOKEN);
    if (DEBUG) {
      console.trace("TryOpenWebSocket URL: " + url);
    }

    this.clearReconnectTimer();

    // Close existing websocket
    if (this.websocket) {
      // Clear the event handlers to prevent a reconnection from the old socket.
      this.websocket.onclose = () => {};
      this.websocket.onmessage = () => {};
      this.websocket.close();
      this.websocket = undefined;
    }

    let ws: WebSocket;
    try {
      ws = new WebSocket(url);
    } catch (e) {
      console.log("Could not open a websocket to " + url, e);
      return false;
    }
    console.log("Websocket opened to " + url);
    this.websocket = ws;
    this.lastMessageAt = Date.now();
    this.reconnectOnConnectionClosed = true;
    // Only move the player to the lobby page if they were logging in.
    // This is to prevent the bug where players flash in/out of the lobby page
    // at random points in the game.
    if (this.state.page === PAGE.LOGIN) {
      this.setState({ page: PAGE.LOBBY });
    }
    const sameLobby = this.state.lobby === lobby && this.state.name === name;
    this.setState({
      name: name,
      lobby: lobby,
      // Keep showing the players while reconnecting to the same lobby.
      usernames: sameLobby ? this.state.usernames : [],
      ready: sameLobby ? this.state.ready : [],
      away: sameLobby ? this.state.away : [],
      joinName: "",
      joinLobby: "",
      joinError: "",
      createLobbyName: "",
      createLobbyError: "",
    });
    // Events of a socket that has been replaced are ignored.
    ws.onmessage = (msg) => {
      if (ws === this.websocket) {
        this.onWebSocketMessage(msg);
      }
    };
    ws.onclose = (event) => {
      if (ws === this.websocket) {
        this.onWebSocketClose(event);
      }
    };
    this.startHeartbeat();
    return true;
  }

  /** Pings the server at a set interval, and notices when it has stopped answering. */
  startHeartbeat() {
    this.stopHeartbeat();
    this.pingInterval = setInterval(() => {
      const ws = this.websocket;
      if (ws === undefined || ws.readyState !== WebSocket.OPEN) {
        return;
      }
      // Several ping rounds without a word from the server: the connection died silently. (Not checked in a
      // background page, where timers are slowed down and the silence may only look long.)
      if (!document.hidden && Date.now() - this.lastMessageAt > PING_INTERVAL * 3) {
        this.reconnectNow();
        return;
      }
      this.sendWSCommand({ command: WSCommandType.PING });
    }, PING_INTERVAL);
  }

  stopHeartbeat() {
    if (this.pingInterval) {
      clearInterval(this.pingInterval);
      this.pingInterval = undefined;
    }
    if (this.pongTimer) {
      clearTimeout(this.pongTimer);
      this.pongTimer = undefined;
    }
  }

  clearReconnectTimer() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = undefined;
    }
  }

  /** Drops the current connection (if any) and connects again at once, with a fresh set of attempts. */
  reconnectNow() {
    if (!this.state.name || !this.state.lobby) {
      return;
    }
    this.failedConnections = 0;
    this.tryOpenWebSocket(this.state.name, this.state.lobby);
  }

  /**
   * Called when the page becomes visible or focused again, or the network comes back.
   * @effects Checks that the connection still works: a closed one is reopened at once, and an open one is
   *          pinged, because a phone or browser that suspended the page often leaves a connection that looks
   *          open but is dead. If the server does not answer in time, the connection is replaced.
   */
  onPageResumed = () => {
    if (document.hidden || !this.reconnectOnConnectionClosed || this.state.page === PAGE.LOGIN) {
      return;
    }
    if (!this.state.name || !this.state.lobby) {
      return;
    }
    const ws = this.websocket;
    if (ws === undefined || ws.readyState === WebSocket.CLOSING || ws.readyState === WebSocket.CLOSED) {
      this.reconnectNow();
    } else if (ws.readyState === WebSocket.OPEN && Date.now() - this.lastMessageAt > 5000) {
      const asked = Date.now();
      if (this.pongTimer) {
        clearTimeout(this.pongTimer);
      }
      this.sendWSCommand({ command: WSCommandType.PING });
      this.pongTimer = setTimeout(() => {
        this.pongTimer = undefined;
        if (this.lastMessageAt < asked) {
          this.reconnectNow();
        }
      }, PONG_TIMEOUT_MS);
    }
  };

  /**
   * Called when the websocket closes.
   * @param event the close event (its code and reason say why the server closed the connection).
   * @effects attempts to reopen the websocket connection, with a pause between the attempts.
   *          If the user pressed the "Leave Lobby" button, joined from another page, or a maximum number of
   *          attempts has been reached ({@code MAX_FAILED_CONNECTIONS}), does not reopen the websocket connection
   *          and returns the user to the login screen with a relevant error message.
   */
  onWebSocketClose(event?: CloseEvent) {
    this.stopHeartbeat();

    console.log(
      "A websocket closed (code " +
        event?.code +
        "): " +
        this.websocket?.url +
        ". Current lobby " +
        this.state.lobby
    );

    if (event && event.code === CLOSE_REPLACED) {
      // The same player joined from another page or tab, and the server gave their seat to it.
      this.reconnectOnConnectionClosed = false;
      this.setState({
        page: PAGE.LOGIN,
        joinName: this.state.name,
        joinLobby: this.state.lobby,
        joinError: "You joined this lobby from another page, so this one was disconnected.",
      });
      this.clearAnimationQueue();
    } else if (event && event.code === CLOSE_KICKED) {
      // The host removed this player.
      this.reconnectOnConnectionClosed = false;
      this.clearAnimationQueue();
      this.returnToLogin("The host removed you from the lobby.");
    } else if (this.reconnectOnConnectionClosed) {
      this.scheduleReconnect(event);
    } else {
      // User purposefully closed the connection.
      if (this.gameOver) {
        // Do not reopen if the game is over, since disconnecting is intentional.
      } else {
        this.returnToLogin("");
      }
    }
  }

  /** Shows the login page again (keeping the name and lobby filled in) with an optional message. */
  returnToLogin(message: string) {
    this.everConnected = false;
    this.failedConnections = 0;
    this.clearReconnectTimer();
    this.setState({
      page: PAGE.LOGIN,
      joinName: this.state.name,
      joinLobby: this.state.lobby,
      joinError: message,
    });
    this.clearAnimationQueue();
  }

  /**
   * Plans the next attempt to connect again after the connection dropped.
   * @effects Waits a little longer after each failed attempt. No attempts are used up while the page is in the
   *          background or the device is offline: the connection is restored when the player comes back (see
   *          {@code onPageResumed}). After {@code MAX_FAILED_CONNECTIONS} failed attempts in a row, gives up
   *          and returns to the login page.
   */
  scheduleReconnect(event?: CloseEvent) {
    if (this.reconnectTimer) {
      return;
    }
    // A player who never got through (a rejected login) is told after a few attempts, not after a minute.
    const maxAttempts = this.everConnected ? MAX_FAILED_CONNECTIONS : 3;
    if (this.failedConnections >= maxAttempts) {
      if (DEBUG) {
        console.log("Disconnecting from lobby.");
      }
      const reason = event && event.reason && !/Exception/.test(event.reason) ? event.reason : "";
      this.returnToLogin(reason ? "Disconnected from the lobby: " + reason : "Disconnected from the lobby.");
      ReactGA.event({
        category: "Lost Server Connection (Terminal)",
        action:
          "User was unable to reconnect to the server. (max attempts reached)",
      });
      return;
    }
    if (document.hidden || navigator.onLine === false) {
      // Wait for the player to come back (or the network to return) instead of using up the attempts.
      return;
    }
    if (this.failedConnections >= 1) {
      // Only show the error bar if the first attempt has failed.
      this.showSnackBar("Lost connection to the server: retrying...");
      ReactGA.event({
        category: "Lost Server Connection",
        action: "User lost connection to the server. (>1 attempts)",
      });
    }
    const delay = RECONNECT_DELAYS_MS[Math.min(this.failedConnections, RECONNECT_DELAYS_MS.length - 1)];
    this.failedConnections += 1;
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = undefined;
      if (this.reconnectOnConnectionClosed) {
        this.tryOpenWebSocket(this.state.name, this.state.lobby);
      }
    }, delay);
  }

  async onWebSocketMessage(msg: MessageEvent) {
    this.failedConnections = 0;
    this.everConnected = true;
    this.lastMessageAt = Date.now();
    if (this.pongTimer) {
      clearTimeout(this.pongTimer);
      this.pongTimer = undefined;
    }
    let message = JSON.parse(msg.data);
    // Decode message contents as communication is encoded
    if (DEBUG) {
      console.log(message);
    }
    switch (message[PARAM_PACKET_TYPE]) {
      case PACKET_LOBBY:
        this.setState({
          usernames: message[PARAM_USERNAMES],
          icons: message[PARAM_ICON],
          ready: message.ready ?? [],
          away: message.away ?? [],
          botTarget: message.botTarget ?? this.state.botTarget,
          testMode: message.testMode ?? this.state.testMode,
          page: PAGE.LOBBY,
        });
        if (message[PARAM_ICON][this.state.name] === defaultPortrait) {
          this.setState({ iconDrawerOpen: true });
        }
        break;

      case PACKET_GAME_STATE:
        if (message !== this.state.gameState) {
          this.onGameStateChanged(message);
        }
        this.setState({ gameState: message, page: PAGE.GAME });
        break;

      case PACKET_OK: // Traverse all listeners and call the functions.
        let i = 0;
        for (i; i < this.okMessageListeners.length && i < 1; i++) {
          this.okMessageListeners[i]();
        }
        this.okMessageListeners = []; // clear all listeners.
        break;

      case PACKET_INVESTIGATION:
        // Trigger investigation screen when the server responds.
        console.log(
          "Investigated player role: " + message[PARAM_INVESTIGATION]
        );
        // Set party to liberal/fascist using sent packet
        const party = message[PARAM_INVESTIGATION];

        this.queueAlert(
          <InvestigationAlert
            party={party}
            target={message[PARAM_TARGET]}
            hideAlert={this.hideAlertAndFinish}
          />,
          false
        );
        break;
      case PACKET_ERROR:
        // The server rejected a command (usually a double tap or a late action). The connection stays
        // open and the server has already re-sent the current game state, so just let the player know.
        if (DEBUG) {
          console.log("Server rejected a command: " + message.message);
        }
        this.okMessageListeners = []; // the rejected command will never be acknowledged.
        this.showSnackBar("That action isn't available right now.");
        break;
      case PACKET_PONG:
      default:
      // No action
    }
  }

  /**
   * Sends a specified command to the server.
   * @param command the String command label.
   * @param params a dictionary of any parameters that need to be provided with the command.
   * @effects sends a message to the server with the following parameters:
   *          {@code PARAM_COMMAND}: {@code command}
   *          {@code PARAM_LOBBY}: {@code this.state.lobby}
   *          {@code PARAM_NAME}: {@code this.state.name}
   *          and each (key, value) pair in {@code params}.
   */
  sendWSCommand(request: ServerRequestPayload) {
    // Do not need to encode name + lobby because this is sent through websocket
    const data: WSCommand = {
      ...request,
      name: this.state.name,
      lobby: this.state.lobby,
    };

    if (DEBUG) {
      console.log(JSON.stringify(data));
    }
    const ws = this.websocket;
    if (ws !== undefined && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(data));
    } else if (request.command === WSCommandType.PING) {
      // Nothing to check on a connection that is not open; the reconnect logic is already at work.
    } else if (ws !== undefined && this.reconnectOnConnectionClosed) {
      // The connection dropped and is being restored. Say so, and make sure that it is being restored now.
      this.showSnackBar("Reconnecting to the server... try again in a moment.");
      this.onPageResumed();
    } else {
      this.showSnackBar(
        "Could not connect to the server. Try refreshing the page if this happens again."
      );
    }
  }

  //</editor-fold>

  /////////////////// Login Page
  // <editor-fold desc="Login Page">

  /**
   * Updates the "Name" field under Join Game.
   * @param text the text to update the text field to.
   */
  updateJoinName = (text: string) => {
    this.setState({
      joinName: text,
    });
    this.checkSecretCode(text, () => this.state.joinName, () => this.setState({ joinName: "" }));
  };

  /**
   * If the text typed in a name field is a valid secret code, unlocks its icons and empties the field so a
   * name can be typed instead. Anything else is left alone.
   * @param text the text in the field.
   * @param current returns the text currently in the field.
   * @param clear empties the field.
   */
  checkSecretCode(text: string, current: () => string, clear: () => void) {
    if (!SECRET_CODE_PATTERN.test(text)) return;
    redeemSecretCode(text).then((unlock) => {
      if (unlock === null) return;
      if (current() === text) clear();
      this.showSnackBar(unlock.icons.length + " secret looks unlocked");
    });
  }

  /**
   * Updates the Lobby field under Join Game.
   * @param text the text to update the text field to.
   */
  updateJoinLobby = (text: string) => {
    this.setState({
      joinLobby: text,
    });
  };

  /**
   * Updates the Name field under Create Lobby.
   * @param text the text to update the text field to.
   */
  updateCreateLobbyName = (text: string) => {
    this.setState({
      createLobbyName: text,
    });
    this.checkSecretCode(
      text,
      () => this.state.createLobbyName,
      () => this.setState({ createLobbyName: "" })
    );
  };

  shouldJoinButtonBeEnabled() {
    return (
      this.state.joinLobby.length === LOBBY_CODE_LENGTH &&
      this.state.joinName.length !== 0
    );
  }

  shouldCreateLobbyButtonBeEnabled() {
    return this.state.createLobbyName.length !== 0;
  }

  /**
   * Attempts to connect to the lobby via websocket.
   */
  onClickJoin = () => {
    this.setState({ joinError: "Connecting..." });
    this.tryLogin(this.state.joinName, this.state.joinLobby)
      .then((response) => {
        if (!response.ok) {
          if (DEBUG) {
            console.log("Response is not ok");
          }
          if (response.status === 404) {
            this.setState({ joinError: "The lobby could not be found." });
            ReactGA.event({
              category: "Login Failed",
              action: "Lobby not found - User unable to connect.",
            });
          } else if (response.status === 403) {
            const name = this.state.joinName;
            response
              .text()
              .then((text) => {
                // A player who has just lost their connection still holds their seat for a short while.
                this.setState({
                  joinError: text.indexOf("lost their connection") >= 0
                    ? text
                    : "There is already a user with the name '" + name + "' in the lobby.",
                });
              })
              .catch(() => {
                this.setState({
                  joinError: "There is already a user with the name '" + name + "' in the lobby.",
                });
              });
            ReactGA.event({
              category: "Login Failed",
              action: "Duplicate name - User unable to connect.",
            });
          } else if (response.status === 488) {
            this.setState({ joinError: "The lobby is currently in a game." });
            ReactGA.event({
              category: "Login Failed",
              action: "Ongoing game - User unable to connect.",
            });
          } else if (response.status === 489) {
            this.setState({ joinError: "The lobby is currently full." });
            ReactGA.event({
              category: "Login Failed",
              action: "Lobby full - User unable to connect.",
            });
          } else {
            this.setState({
              joinError:
                "There was an error connecting to the server. Please try again.",
            });
            ReactGA.event({
              category: "Login Failed",
              action: "Misc - User was unable to connect.",
            });
          }
        } else {
          // Username and lobby were verified. Try to open websocket.
          if (
            !this.tryOpenWebSocket(this.state.joinName, this.state.joinLobby)
          ) {
            this.setState({
              joinError:
                "There was an error connecting to the server. Please try again.",
            });
          } else {
            // Save the username and lobby login
            Cookies.set(COOKIE_NAME, this.state.name, { expires: 7 });
            Cookies.set(COOKIE_LOBBY, this.state.joinLobby);
          }
        }
      })
      .catch(() => {
        this.setState({
          joinError:
            "There was an error contacting the server. Please wait and try again.",
        });
      });
  };

  /**
   * Attempts to connect to the server and create a new lobby, and then opens a connection to the lobby.
   */
  onClickCreateLobby = () => {
    this.setState({ createLobbyError: "Connecting..." });
    this.tryCreateLobby()
      .then((response) => {
        if (response.ok) {
          response.text().then((lobbyCode) => {
            if (!this.tryOpenWebSocket(this.state.createLobbyName, lobbyCode)) {
              // if the connection failed
              this.setState({
                createLobbyError:
                  "There was an error connecting to the server. Please try again.",
              });
              ReactGA.event({
                category: "Lobby Creation Failed",
                action: "Failed to create a new lobby.",
              });
            } else {
              ReactGA.event({
                category: "Lobby Created",
                action: "Successfully created new lobby.",
              });
              // Save the username and lobby login
              Cookies.set(COOKIE_NAME, this.state.name, { expires: 7 });
              Cookies.set(COOKIE_LOBBY, lobbyCode);
            }
          });
        } else {
          this.setState({
            createLobbyError:
              "There was an error connecting to the server. Please try again.",
          });
          ReactGA.event({
            category: "Lobby Creation Failed",
            action: "Failed to create a new lobby.",
          });
        }
      })
      .catch(() => {
        this.setState({
          createLobbyError:
            "There was an error connecting to the server. Please try again.",
        });
        ReactGA.event({
          category: "Lobby Creation Failed",
          action: "Failed to create a new lobby.",
        });
      });
  };

  renderLoginPage() {
    return (
      <>
        <StartPage
          joinLobby={this.state.joinLobby}
          joinName={this.state.joinName}
          joinError={this.state.joinError}
          createName={this.state.createLobbyName}
          createError={this.state.createLobbyError}
          lobbyCodeLength={LOBBY_CODE_LENGTH}
          canJoin={this.shouldJoinButtonBeEnabled()}
          canCreate={this.shouldCreateLobbyButtonBeEnabled()}
          onJoinLobbyChange={this.updateJoinLobby}
          onJoinNameChange={this.updateJoinName}
          onCreateNameChange={this.updateCreateLobbyName}
          onJoin={this.onClickJoin}
          onCreate={this.onClickCreateLobby}
        />
        <div className="snackbar-host">
          <div id="snackbar">{this.state.snackbarMessage}</div>
        </div>
      </>
    );
  }

  //</editor-fold>

  /////////////////// Lobby Page
  //<editor-fold desc="Lobby Page">

  /**
   * Renders the playerlist as a sequence of paragraph tags.
   * Written as "{@literal <p>} - {@code username} {@literal </p>}".
   */
  renderPlayerList() {
    return this.state.usernames.map((name: string, i: number) => {
      return (
        <Player
          key={i}
          name={i === 0 ? name : name + " [Host]"}
          showRole={false}
          icon={this.state.icons[name]}
          isBusy={this.state.icons[name] === defaultPortrait}
          highlight={name === this.state.name}
        />
      );
    });
  }

  onClickChangeIcon() {
    this.setState({ iconDrawerOpen: true });
  }

  /**
   * Determines whether the 'Start Game' button in the lobby should be enabled.
   */
  shouldStartGameBeEnabled() {
    // Verify that all players have icons
    for (let i = 0; i < this.state.usernames.length; i++) {
      if (this.state.icons[this.state.usernames[i]] === defaultPortrait) {
        return false;
      }
    }
    return true;
  }

  /**
   * Contacts the server and requests to start the game.
   */
  onClickStartGame() {
    ReactGA.event({
      category: "Starting Game",
      action: this.state.usernames.length + " players started game.",
    });
    this.sendWSCommand({ command: WSCommandType.START_GAME });
  }

  /** Sends the bot options (fill size) to the server. Only the lobby VIP sees the controls. Bots always act fast. */
  sendBotOptions(botPlayers: number) {
    this.sendWSCommand({
      command: WSCommandType.SET_BOT_OPTIONS,
      botPlayers,
      botDelay: BOT_DELAY_IN_SEC,
    });
  }

  /** Host chooses between Normal (secret roles) and Test mode (every role visible when playing alone). */
  sendTestMode(testMode: boolean) {
    this.sendWSCommand({ command: WSCommandType.SET_TEST_MODE, testMode });
  }

  onClickLeaveLobby() {
    this.reconnectOnConnectionClosed = false;
    this.clearReconnectTimer();
    this.stopHeartbeat();
    const ws = this.websocket;
    if (ws !== undefined) {
      // The close code tells the server that this player left on purpose, so their seat is freed at once
      // instead of being held for a while as for a dropped connection.
      ws.onclose = () => {};
      ws.onmessage = () => {};
      if (ws.readyState === WebSocket.OPEN) {
        ws.close(CLOSE_LEFT, "left");
      } else {
        ws.close();
      }
      this.websocket = undefined;
    }
    // Do not wait for the close event: on a connection that has died silently it can take a long time.
    this.returnToLogin("");
  }

  /** Tells the host that this player is ready to start (or not any more). */
  sendReady(ready: boolean) {
    this.sendWSCommand({ command: WSCommandType.SET_READY, ready });
  }

  onClickCopy() {
    const link = lobbyLink(this.state.lobby);
    const fallback = () => {
      const text = document.getElementById("linkText") as HTMLInputElement | null;
      if (text === null) {
        return;
      }
      text.select();
      text.setSelectionRange(0, 999999);
      document.execCommand("copy");
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(link).catch(fallback);
    } else {
      fallback();
    }
    this.showSnackBar("Invite link copied!");
  }

  showSnackBar(message: string) {
    this.setState({ snackbarMessage: message });
    let snackbar = document.getElementById("snackbar");
    if (snackbar === null) {
      return;
    }
    snackbar.className = "show";
    this.snackbarMessages++;
    setTimeout(() => {
      this.snackbarMessages--;
      if (this.snackbarMessages === 0) {
        snackbar!.className = snackbar!.className.replace("show", "");
      }
    }, 3000);
  }

  /** Sends the host's request to remove a player and closes the dialogs. */
  confirmKick() {
    const target = this.state.kickTarget;
    if (target !== undefined) {
      this.sendWSCommand({ command: WSCommandType.KICK_PLAYER, target });
    }
    this.setState({ kickTarget: undefined, showKickList: false });
  }

  /** The host's dialogs for removing a player: the confirmation, and in a game the list to pick from. */
  renderKickDialogs(inGame: boolean, players: string[], icons: Record<string, string>) {
    const target = this.state.kickTarget;
    return (
      <>
        {inGame && this.state.showKickList && !this.state.gameOverState && (
          <KickPicker
            players={players}
            icons={icons}
            onPick={(name) => this.setState({ kickTarget: name })}
            onClose={() => this.setState({ showKickList: false })}
          />
        )}
        {target !== undefined && (
          <KickConfirm
            name={target}
            inGame={inGame}
            onConfirm={() => this.confirmKick()}
            onCancel={() => this.setState({ kickTarget: undefined })}
          />
        )}
      </>
    );
  }

  renderLobbyPage() {
    const usernames = this.state.usernames;
    // The first player in the lobby is the host (VIP): only they can change settings and start.
    const isVIP = usernames.length > 0 && usernames[0] === this.state.name;
    const humans = usernames.length;
    const target = Math.max(5, Math.min(10, this.state.botTarget));
    const bots = Math.max(0, target - humans);
    const pickingLook = usernames.filter((n) => this.state.icons[n] === defaultPortrait);
    // Everyone except the host tells the host that they are ready; a player who lost their connection is not.
    const isReady = (n: string) => this.state.ready.indexOf(n) >= 0;
    const isAway = (n: string) => this.state.away.indexOf(n) >= 0;
    const others = usernames.slice(1);
    const notReady = others.filter((n) => !isReady(n) || isAway(n));
    const away = usernames.filter(isAway);
    const everyoneReady = notReady.length === 0;
    const meReady = isReady(this.state.name);
    const meHasLook = this.state.icons[this.state.name] !== undefined && this.state.icons[this.state.name] !== defaultPortrait;
    // The host cannot start while somebody is away: they would be in the game but not at the table.
    const canStart = isVIP && this.shouldStartGameBeEnabled() && away.length === 0;
    // Test mode only applies when the host is alone; with more humans the server keeps roles secret.
    const testActive = this.state.testMode && humans === 1;

    const seats: JSX.Element[] = [];
    usernames.forEach((name, i) => {
      const icon = this.state.icons[name];
      const hasLook = icon !== undefined && icon !== defaultPortrait;
      const isYou = name === this.state.name;
      seats.push(
        <div key={name} className={"lb-seat lb-seat-human" + (isYou ? " lb-seat-you" : "")}>
          {hasLook ? (
            <img className="lb-avatar" src={portraits[icon]} alt="" />
          ) : (
            <div className="lb-avatar lb-avatar-empty">?</div>
          )}
          <div className="lb-seat-name">{name}</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: "center" }}>
            {i === 0 && <span className="lb-tag lb-tag-host">Host</span>}
            {isYou && <span className="lb-tag">You</span>}
            {!hasLook && <span className="lb-tag">Picking a look…</span>}
            {i > 0 && isAway(name) && <span className="lb-tag lb-tag-away">Away</span>}
            {i > 0 && !isAway(name) && hasLook && isReady(name) && (
              <span className="lb-tag lb-tag-ready">Ready ✓</span>
            )}
            {i > 0 && !isAway(name) && hasLook && !isReady(name) && <span className="lb-tag">Not ready</span>}
          </div>
          {isYou && (
            <button className="lb-change" onClick={this.onClickChangeIcon}>
              Change look
            </button>
          )}
          {isVIP && i > 0 && (
            <button
              className="lb-kick"
              aria-label={"Remove " + name + " from the lobby"}
              onClick={() => this.setState({ kickTarget: name })}
            >
              Remove
            </button>
          )}
        </div>
      );
    });
    for (let i = 0; i < bots && seats.length < 10; i++) {
      seats.push(
        <div key={"bot" + i} className="lb-seat lb-seat-bot">
          <div className="lb-seat-ghost">Bot</div>
          <div className="lb-seat-sub">Fills this seat at start</div>
        </div>
      );
    }
    while (seats.length < 10) {
      seats.push(
        <div key={"open" + seats.length} className="lb-seat lb-seat-open">
          <div className="lb-seat-ghost">Open</div>
          <div className="lb-seat-sub">Waiting for a player</div>
        </div>
      );
    }

    const startButton = (
      isVIP ? (
        <button
          className={
            "gold-button gold-button-large lb-start" +
            (canStart && everyoneReady ? " attention-button" : "")
          }
          onClick={this.onClickStartGame}
          disabled={!canStart}
        >
          {canStart && everyoneReady && <span className="gold-sweep" />}
          <span className="gold-label">{everyoneReady ? "START GAME" : "START ANYWAY"}</span>
        </button>
      ) : (
        <button
          className={
            "gold-button gold-button-large lb-start lb-ready" +
            (meReady ? " lb-ready-on" : meHasLook ? " attention-button" : "")
          }
          aria-pressed={meReady}
          onClick={() => this.sendReady(!meReady)}
          disabled={!meHasLook}
        >
          {!meReady && meHasLook && <span className="gold-sweep" />}
          <span className="gold-label">{meReady ? "READY ✓" : "I'M READY"}</span>
        </button>
      )
    );

    let startHint = "";
    if (!isVIP) {
      if (!meHasLook) {
        startHint = "Pick a look, then tell the host that you are ready.";
      } else if (meReady) {
        startHint = "Waiting for " + (usernames[0] || "the host") + " (host) to start. Tap again if you are not ready after all.";
      } else {
        startHint = "Tell " + (usernames[0] || "the host") + " (host) that you are ready to start.";
      }
    } else if (pickingLook.length > 0) {
      startHint = "Waiting for " + pickingLook.join(", ") + " to pick a look.";
    } else if (away.length > 0) {
      startHint = away.join(", ") + (away.length === 1 ? " is" : " are") + " away. Wait for them to reconnect.";
    } else if (!everyoneReady) {
      startHint = "Not ready yet: " + notReady.join(", ") + ".";
    } else if (bots > 0) {
      startHint =
        (others.length > 0 ? "Everyone is ready. " : "") +
        bots + (bots === 1 ? " bot joins" : " bots join") + " when you start.";
    } else if (others.length > 0) {
      startHint = "Everyone is ready.";
    }

    const iconDrawer = (
      <IconDrawer
        open={this.state.iconDrawerOpen}
        user={this.state.name}
        isHost={isVIP}
        players={usernames}
        playerToIcon={this.state.icons}
        sendWSCommand={this.sendWSCommand}
        onClose={() => this.setState({ iconDrawerOpen: false })}
      />
    );

    if (isRoundTable()) {
      // "Lobby B": the seats around an oval table, the invite and settings on the table. You sit at the bottom.
      const mySeat = Math.max(0, usernames.indexOf(this.state.name));
      return (
        <div className="lb-page lbb-page">
          <CustomAlert show={this.state.showAlert}>
            {this.state.alertContent}
          </CustomAlert>

          <div className="lb-topbar">
            <div className="lb-logo">SECRET HITLER</div>
            <div style={{ flex: "1 1 auto" }} />
            <a
              className="lb-link"
              href="https://www.secrethitler.com/assets/Secret_Hitler_Rules.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to play
            </a>
            <button className="lb-leave lbb-leave" onClick={this.onClickLeaveLobby}>
              Leave lobby
            </button>
          </div>

          <div className="lbb-stage">
            <div className="lbb-seats">
            {seats.map((seat, i) => {
              const pos = roundSeatPosition(i, seats.length, mySeat, 44, 38);
              return (
                <div
                  className="lbb-slot"
                  key={seat.key}
                  style={{ "--x": pos.x + "%", "--y": pos.y + "%" } as React.CSSProperties}
                >
                  {seat}
                </div>
              );
            })}
            </div>

            <section className="lbb-table" aria-label="Invite and settings">
              <div className="lbb-code-row">
                <span className="lb-label">LOBBY CODE</span>
                <span className="lb-code">{this.state.lobby}</span>
              </div>
              <div className="lbb-row">
                <label className="lb-field-label" htmlFor="linkText">
                  Invite link
                </label>
                <input
                  id="linkText"
                  className="lbb-link-input"
                  readOnly={true}
                  value={lobbyLink(this.state.lobby)}
                  onFocus={(e) => e.target.select()}
                />
                <button className="lb-copy" onClick={this.onClickCopy}>
                  COPY
                </button>
              </div>
              <div className="lbb-row">
                <span className="lb-field-label" id="mode-label">Mode</span>
                <div className="lb-pills" role="radiogroup" aria-labelledby="mode-label">
                  <button
                    role="radio"
                    aria-checked={!testActive}
                    className={"lb-pill" + (!testActive ? " on" : "")}
                    disabled={!isVIP}
                    onClick={() => this.sendTestMode(false)}
                    title="Roles stay secret"
                  >
                    Normal
                  </button>
                  <button
                    role="radio"
                    aria-checked={testActive}
                    className={"lb-pill" + (testActive ? " on" : "")}
                    disabled={!isVIP || humans > 1}
                    onClick={() => this.sendTestMode(true)}
                    title={humans > 1 ? "Only when you play alone" : "You see every role"}
                  >
                    Test
                  </button>
                </div>
              </div>
              <div className="lbb-row">
                <span className="lb-field-label" id="bot-target-label">Bots fill to</span>
                <div className="lb-pills" role="group" aria-labelledby="bot-target-label">
                  {[5, 6, 7, 8, 9, 10].map((n) => (
                    <button
                      key={n}
                      className={"lb-pill" + (n === target ? " on" : "")}
                      aria-pressed={n === target}
                      disabled={!isVIP}
                      onClick={() => this.sendBotOptions(n)}
                    >
                      {n}
                    </button>
                  ))}
                </div>
              </div>
              <div className="lbb-row lbb-row-theme">
                <ThemePicker onLayoutChange={this.switchLayout} />
              </div>
              {startButton}
              {startHint && <p className="lb-note lbb-hint">{startHint}</p>}
              {!isVIP && <p className="lb-note lbb-hint">Only the host can change the settings.</p>}
            </section>
          </div>

          {iconDrawer}
          {this.renderKickDialogs(false, [], this.state.icons)}

          <div className="snackbar-host">
            <div id="snackbar">{this.state.snackbarMessage}</div>
          </div>
        </div>
      );
    }

    return (
      <div className="lb-page">
        <CustomAlert show={this.state.showAlert}>
          {this.state.alertContent}
        </CustomAlert>

        <div className="lb-topbar">
          <div className="lb-logo">SECRET HITLER</div>
          <div style={{ flex: "1 1 auto" }} />
          <a
            className="lb-link"
            href="https://www.secrethitler.com/assets/Secret_Hitler_Rules.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            How to play
          </a>
        </div>

        <div className="lb-main">
          <section className="lb-panel" aria-label="Invite and settings">
            <div>
              <div className="lb-label">LOBBY CODE</div>
              <div className="lb-code">{this.state.lobby}</div>
            </div>

            <div>
              <label className="lb-field-label" htmlFor="linkText">
                Invite link
              </label>
              <div className="lb-invite">
                <input
                  id="linkText"
                  readOnly={true}
                  value={lobbyLink(this.state.lobby)}
                  onFocus={(e) => e.target.select()}
                />
                <button className="lb-copy" onClick={this.onClickCopy}>
                  COPY
                </button>
              </div>
            </div>

            <div>
              <div className="lb-field-label" id="mode-label">
                Game mode
              </div>
              <div className="lb-modes" role="radiogroup" aria-labelledby="mode-label">
                <button
                  role="radio"
                  aria-checked={!testActive}
                  className={"lb-mode" + (!testActive ? " on" : "")}
                  disabled={!isVIP}
                  onClick={() => this.sendTestMode(false)}
                >
                  <span className="lb-mode-title">Normal</span>
                  <span className="lb-mode-text">Roles stay secret. Bots fill empty seats.</span>
                </button>
                <button
                  role="radio"
                  aria-checked={testActive}
                  className={"lb-mode" + (testActive ? " on" : "")}
                  disabled={!isVIP || humans > 1}
                  onClick={() => this.sendTestMode(true)}
                >
                  <span className="lb-mode-title">Test mode</span>
                  <span className="lb-mode-text">
                    {humans > 1 ? "Only when you play alone." : "You see every role. Solo with bots."}
                  </span>
                </button>
              </div>
            </div>

            <div>
              <div className="lb-field-label" id="bot-target-label">
                Fill empty seats with bots up to
              </div>
              <div className="lb-pills" role="group" aria-labelledby="bot-target-label">
                {[5, 6, 7, 8, 9, 10].map((n) => (
                  <button
                    key={n}
                    className={"lb-pill" + (n === target ? " on" : "")}
                    aria-pressed={n === target}
                    disabled={!isVIP}
                    onClick={() => this.sendBotOptions(n)}
                  >
                    {n}
                  </button>
                ))}
              </div>
            </div>

            <div>
              {!isVIP && <p className="lb-note" style={{ marginTop: 8 }}>Only the host can change these.</p>}
            </div>

            <ThemePicker onLayoutChange={this.switchLayout} />

            <div className="lb-spacer" />
            {startButton}
            {startHint && <p className="lb-note" style={{ textAlign: "center" }}>{startHint}</p>}
            <button className="lb-leave" onClick={this.onClickLeaveLobby}>
              Leave lobby
            </button>
          </section>

          <section className="lb-seats-area" aria-label="Players">
            <div className="lb-seats-head">
              <div className="lb-seats-title">Players</div>
              <div className="lb-seats-sub">
                {humans} joined
                {others.length > 0 ? " · " + (others.length - notReady.length) + " of " + others.length + " ready" : ""}
                {bots > 0 ? " · " + bots + (bots === 1 ? " bot" : " bots") + " will fill to " + target : ""}
                {" · up to 10"}
              </div>
            </div>
            <div className="lb-seats">{seats}</div>
            <p className="lb-note">
              {testActive
                ? "Test mode: when the game starts you will see every player's role. Choose Normal to play against bots with secret roles."
                : humans === 1
                ? "Normal mode: roles are secret, even when you play alone against bots. Choose Test mode to see every role."
                : "Normal mode: roles are secret. Bots take any empty seats up to the number you chose."}
            </p>
            <p className="lb-footer">
              Based on{" "}
              <a
                href="https://github.com/ShrimpCryptid/Secret-Hitler-Online"
                target="_blank"
                rel="noopener noreferrer"
              >
                Secret Hitler Online by ShrimpCryptid
              </a>{" "}
              (CC BY-NC-SA 4.0).
            </p>
          </section>
        </div>

        <IconDrawer
          open={this.state.iconDrawerOpen}
          user={this.state.name}
          isHost={isVIP}
          players={usernames}
          playerToIcon={this.state.icons}
          sendWSCommand={this.sendWSCommand}
          onClose={() => this.setState({ iconDrawerOpen: false })}
        />
        {this.renderKickDialogs(false, [], this.state.icons)}

        <div className="snackbar-host">
          <div id="snackbar">{this.state.snackbarMessage}</div>
        </div>
      </div>
    );
  }

  //</editor-fold>

  /////////////////// Game Page
  //<editor-fold desc="Game Page">

  /** Opens or closes the tips sidebar (and remembers the choice in this browser). */
  toggleTips = () => {
    const open = !this.state.showTips;
    writeTipsOpen(open);
    this.setState({ showTips: open });
  };

  /** Switches this player's layout (A or B) on the spot; the game and the connection are not affected. */
  switchLayout = (round: boolean) => {
    setRoundTable(round);
    this.forceUpdate();
  };

  /**
   * Queues a full-screen reveal (countdown, then a card that turns over to show Hitler / not Hitler).
   * Everyone sees exactly the same scene, the player in question too. While it is up, nothing else can close it
   * and the game over screen waits for it, so the result is always seen before the awards start.
   */
  queueReveal(
    kind: "execution" | "election",
    target: string,
    newState: GameState,
    wasHitler: boolean,
    name: string
  ): void {
    const content = (
      <ExecutionDrama
        kind={kind}
        target={target}
        icon={newState.icon[target]}
        president={newState[PARAM_PRESIDENT]}
        wasHitler={wasHitler}
        onDone={() => {
          this.revealActive = false;
          if (kind === "execution" && target === name) {
            // Only now does the executed player's own screen start treating them as out of the game.
            this.userIsExecuted = true;
          }
          this.hideAlertAndFinish();
        }}
      />
    );
    this.addAnimationToQueue(() => {
      this.revealActive = true;
      this.setState({ alertContent: content, showAlert: true });
    });
  }

  showExecutionResults(name: string, newState: GameState): void {
    const target = newState.targetUser!;
    this.queueReveal(
      "execution",
      target,
      newState,
      newState.state === LobbyState.LIBERAL_VICTORY_EXECUTION,
      name
    );
  }

  /**
   * Queues animations for when the game state has changed.
   * @param newState {Object} the new game state sent from the server.
   */
  onGameStateChanged(newState: GameState) {
    let oldState = this.state.gameState;
    let name = this.state.name;
    let isPresident = this.state.name === newState.president;
    let isChancellor = this.state.name === newState.chancellor;
    let state = newState.state;
    // The player who has just been executed is treated as out of the game only after the reveal has played
    // (see queueReveal), so that their screen runs exactly like everyone else's until then.
    const nowDead = newState.players[name]?.alive === false;
    const justExecuted = nowDead && oldState.players?.[name]?.alive === true;
    this.userIsExecuted = nowDead && !justExecuted;

    // If last state was setup, which indicates that the client is re-entering the game or starting the game, then
    // we set the card count, liberal/fascist policy count, and the tracker.
    if (
      oldState.hasOwnProperty(PARAM_STATE) &&
      oldState[PARAM_STATE] === STATE_SETUP
    ) {
      this.setState({
        liberalPolicies: newState.liberalPolicies,
        fascistPolicies: newState.fascistPolicies,
        electionTracker: newState.electionTracker,
        shownState: newState,
      });
    }

    // Check for changes in enacted policies and election tracker.
    const statesToShowPolicyFor = [
      LobbyState.POST_LEGISLATIVE,
      LobbyState.PP_INVESTIGATE,
      LobbyState.PP_EXECUTION,
      LobbyState.PP_ELECTION,
      LobbyState.PP_PEEK,
      LobbyState.FASCIST_VICTORY_POLICY,
      LobbyState.LIBERAL_VICTORY_POLICY,
    ];
    if (statesToShowPolicyFor.includes(state)) {
      // Check if the election tracker changed positions.
      if (newState.electionTracker !== this.state.gameState.electionTracker) {
        let newPos = newState.electionTracker;
        let advancedToThree = newPos === 0 && newState.electionTrackerAdvanced;
        // We ignore all resets to 0, unless that reset was caused by the election tracker reaching 3.
        if (newPos !== 0 || advancedToThree) {
          // If the last phase was voting, we failed due to voting. Therefore, show votes.
          if (oldState[PARAM_STATE] === STATE_CHANCELLOR_VOTING) {
            //this.queueAlert(<RoleAlert onClick={this.hideAlertAndFinish} />);
            this.addAnimationToQueue(() => this.showVotes(newState));
          }

          let trackerPosition = newPos;
          if (advancedToThree) {
            // If the tracker was reset because it advanced to 3, show it moving to 3 in the dialog box.
            trackerPosition = 3;
          }
          this.queueAlert(
            <ElectionTrackerAlert
              trackerPosition={trackerPosition}
              closeAlert={this.hideAlertAndFinish}
            />
          );
        }
      }

      let liberalChanged =
        newState.liberalPolicies !== oldState.liberalPolicies;
      let fascistChanged =
        newState.fascistPolicies !== oldState.fascistPolicies;

      if (liberalChanged || fascistChanged) {
        // Show an alert with the new policy
        this.queueAlert(
          <PolicyEnactedAlert
            hideAlert={this.hideAlertAndFinish}
            policyType={newState.lastPolicy}
          />
        );
      }

      // Update the decks, board with the new policies / election tracker.
      this.addAnimationToQueue(() => {
        if (liberalChanged || fascistChanged) {
          playSound(
            newState.lastPolicy === PolicyType.FASCIST
              ? "fascistPolicy"
              : "liberalPolicy"
          );
        }
        this.setState({
          liberalPolicies: newState.liberalPolicies,
          fascistPolicies: newState.fascistPolicies,
          electionTracker: newState.electionTracker,
        });
        setTimeout(() => this.onAnimationFinish(), 500);
      });
    }

    // The board catches up with the new state once the vote, tracker and policy animations above have played.
    // Where an alert below still has to announce a result (an execution, an investigation, the end of the
    // game), the board waits for those too.
    const announcesResult =
      isVictoryState(state) ||
      (state === LobbyState.POST_LEGISLATIVE &&
        [
          LobbyState.PP_ELECTION,
          LobbyState.PP_EXECUTION,
          LobbyState.PP_INVESTIGATE,
        ].includes(newState.lastState));
    if (!announcesResult) {
      this.queueShownState(newState);
    }

    // Check for state change
    if (newState[PARAM_STATE] !== this.state.gameState[PARAM_STATE]) {
      // state has changed
      switch (newState[PARAM_STATE]) {
        case STATE_CHANCELLOR_NOMINATION:
          if (
            newState.electionTracker === 0 &&
            newState.liberalPolicies === 0 &&
            newState.fascistPolicies === 0
          ) {
            // If the game has just started (everything in default state), show the player's role.
            this.queueAlert(
              <RoleAlert
                role={newState.players[this.state.name].id}
                gameState={newState}
                name={name}
                onClick={() => {
                  this.hideAlertAndFinish();
                }}
              />,
              false
            );
          }

          this.queueEventUpdate("CHANCELLOR NOMINATION");
          this.queueStatusMessage(
            "Waiting for president to nominate a chancellor."
          );

          if (isPresident) {
            // In the Hitler zone, sound the alarm instead of the normal "your turn" ding.
            this.queueSound(
              newState.fascistPolicies >= 3 ? "alarm" : "yourTurn"
            );
            //Show the chancellor nomination window.
            this.queueAlert(
              SelectNominationPrompt(name, newState, this.sendWSCommand)
            );
          }

          break;

        case STATE_CHANCELLOR_VOTING:
          this.setState({ statusBarText: "" });
          this.queueEventUpdate("VOTING");
          this.queueStatusMessage("Waiting for all players to vote.");
          // Check if the player is dead or has already voted-- if so, do not show the voting prompt.
          if (
            newState.players[name][PLAYER_IS_ALIVE] &&
            !Object.keys(newState.userVotes).includes(name)
          ) {
            this.queueSound(
              newState.fascistPolicies >= 3 ? "alarm" : "yourTurn"
            );
            this.queueAlert(
              <VotingPrompt
                gameState={newState}
                sendWSCommand={this.sendWSCommand}
                user={this.state.name}
              />,
              true
            );
          }

          break;

        case STATE_LEGISLATIVE_PRESIDENT:
          // The vote completed, so show the votes.
          this.addAnimationToQueue(() => this.showVotes(newState));
          // In the Hitler zone a successful vote also tells the table whether the new Chancellor is Hitler.
          // (Only on a passed vote: this state is never reached after a failed one.)
          if (newState.fascistPolicies >= 3) {
            this.queueReveal("election", newState.chancellor, newState, false, name);
          }
          this.queueEventUpdate("LEGISLATIVE SESSION");

          // TODO: Animate cards being pulled from the draw deck for all users.

          this.queueStatusMessage(
            "Waiting for the president to choose a policy to discard."
          );

          if (isPresident) {
            if (!newState.presidentChoices) {
              throw new Error("President choices not found.");
            }
            this.queueSound("yourTurn");
            this.queueAlert(
              <PresidentLegislativePrompt
                policyOptions={newState.presidentChoices}
                chancellor={newState.chancellor}
                sendWSCommand={this.sendWSCommand}
              />
            );
          }

          break;

        case STATE_LEGISLATIVE_CHANCELLOR:
          this.queueStatusMessage(
            newState.vetoOccurred
              ? "The president denied the veto. Waiting for the chancellor to enact a policy."
              : "Waiting for the chancellor to choose a policy to enact."
          );
          if (isChancellor) {
            if (!newState.chancellorChoices) {
              throw new Error("Chancellor choices not found.");
            }
            this.queueSound("yourTurn");
            this.queueAlert(
              <ChancellorLegislativePrompt
                fascistPolicies={newState.fascistPolicies}
                showError={(message: string) =>
                  this.setState({ snackbarMessage: message })
                }
                policyOptions={newState.chancellorChoices}
                president={newState.president}
                // The veto was asked for and refused (the flag stays set for the rest of the turn).
                vetoDenied={newState.vetoOccurred}
                sendWSCommand={this.sendWSCommand}
                // Disable if veto has already happened
                enableVeto={
                  newState.fascistPolicies === 5 && !newState.vetoOccurred
                }
              />
            );
          }
          break;

        case STATE_LEGISLATIVE_PRESIDENT_VETO:
          this.queueStatusMessage(
            "Chancellor has motioned to veto the agenda. Waiting for the president to decide."
          );
          if (isPresident) {
            this.queueAlert(
              <VetoPrompt
                chancellor={newState.chancellor}
                sendWSCommand={this.sendWSCommand}
                electionTracker={newState.electionTracker}
              />,
              true
            );
          }
          break;

        case STATE_PP_PEEK:
          this.queueEventUpdate("PRESIDENTIAL POWER");
          if (isPresident) {
            if (!newState.peek) {
              throw new Error("Peek policies not found.");
            }
            this.queueAlert(
              <PeekPrompt
                policies={newState.peek}
                sendWSCommand={this.sendWSCommand}
              />,
              true
            );
          } else {
            this.queueStatusMessage(
              "Peek: President is previewing the next 3 policies."
            );
          }
          break;

        case STATE_PP_ELECTION:
          this.queueEventUpdate("PRESIDENTIAL POWER");
          if (isPresident) {
            this.queueAlert(
              SelectSpecialElectionPrompt(name, newState, this.sendWSCommand)
            );
          } else {
            this.queueStatusMessage(
              "Special Election: President is choosing the next president."
            );
          }
          break;

        case STATE_PP_EXECUTION:
          this.queueEventUpdate("PRESIDENTIAL POWER");
          if (isPresident) {
            this.queueAlert(
              SelectExecutionPrompt(name, newState, this.sendWSCommand),
              true
            );
          } else {
            this.queueStatusMessage(
              "Execution: President is choosing a player to execute."
            );
          }
          break;

        case STATE_PP_INVESTIGATE:
          this.queueEventUpdate("PRESIDENTIAL POWER");
          if (isPresident) {
            this.queueAlert(
              SelectInvestigationPrompt(name, newState, this.sendWSCommand)
            );
          } else {
            this.queueStatusMessage(
              "Investigation: President is choosing a player to investigate."
            );
          }
          break;

        case STATE_POST_LEGISLATIVE:
          // Show results of any special elections, executions, or investigations.
          switch (newState.lastState) {
            case STATE_PP_ELECTION:
              if (!isPresident) {
                console.log("Special Election Alert: " + newState.targetUser);
                this.queueAlert(
                  <ButtonPrompt
                    label={"SPECIAL ELECTION"}
                    footerText={
                      newState[PARAM_PRESIDENT] +
                      " has chosen " +
                      newState.targetUser +
                      " to be the next president." +
                      "\nThe normal presidential order will resume after the next round."
                    }
                    buttonText={"OKAY"}
                    buttonOnClick={this.hideAlertAndFinish}
                  >
                    <PlayerDisplay
                      user={name}
                      gameState={newState}
                      showLabels={false}
                      players={[newState.targetUser!]}
                    />
                  </ButtonPrompt>,
                  false
                );
              }
              break;
            case STATE_PP_EXECUTION:
              // If player was executed
              this.showExecutionResults(name, newState);
              break;
            case STATE_PP_INVESTIGATE:
              if (!isPresident) {
                let isTarget = newState.targetUser === name;
                let footerText = isTarget
                  ? `You have been investigated by ${newState[PARAM_PRESIDENT]}. The president now knows your party affiliation.`
                  : `${newState.targetUser} has been investigated by ${newState[PARAM_PRESIDENT]}. The president now knows their party affiliation.`;
                this.queueAlert(
                  <ButtonPrompt
                    label={"INVESTIGATION RESULTS"}
                    // If target: You have been investigated by [President Name].
                    //            The president now knows your party affiliation.
                    // If not target: [Target Name] has been investigated by [President Name].
                    //                The president now knows their party affiliation.
                    footerText={footerText}
                    buttonOnClick={this.hideAlertAndFinish}
                    buttonText={"OKAY"}
                  >
                    <PlayerDisplay
                      user={name}
                      gameState={newState}
                      showLabels={false}
                      players={[newState.targetUser!]}
                    />
                  </ButtonPrompt>,
                  true
                );
              } else {
                // Is President; do nothing because we handle the
                // response directly from the server.
              }
              break;
            case STATE_PP_PEEK: // No additional case is necessary for peeking.
            default:
          }

          if (isPresident) {
            this.queueSound("yourTurn");
          }
          this.queueStatusMessage(
            "Waiting for the president to end their term."
          );
          break;

        case STATE_LIBERAL_VICTORY_EXECUTION:
        case STATE_FASCIST_VICTORY_ELECTION:
        case STATE_FASCIST_VICTORY_POLICY:
        case STATE_LIBERAL_VICTORY_POLICY:
          // Show normal enactments when victory events happen.
          if (newState.state === STATE_LIBERAL_VICTORY_EXECUTION) {
            this.showExecutionResults(name, newState);
          }
          if (newState.state === STATE_FASCIST_VICTORY_ELECTION) {
            this.addAnimationToQueue(() => this.showVotes(newState));
            this.queueReveal("election", newState.chancellor, newState, true, name);
          }
          // Policies will already be shown for policy-based victories.
          // If the game was won via election, show the votes.

          let state = newState.state;
          let fascistVictoryPolicy = state === STATE_FASCIST_VICTORY_POLICY;
          let fascistVictoryElection = state === STATE_FASCIST_VICTORY_ELECTION;
          let liberalVictoryPolicy = state === STATE_LIBERAL_VICTORY_POLICY;
          let liberalVictoryExecution =
            state === STATE_LIBERAL_VICTORY_EXECUTION;
          let playerID = newState.players[name].id;
          let playerWon =
            (playerID === Role.LIBERAL &&
              (liberalVictoryExecution || liberalVictoryPolicy)) ||
            (playerID !== Role.LIBERAL &&
              (fascistVictoryElection || fascistVictoryPolicy));

          // Register player victory/loss with analytics.
          // TODO: Only register if player is host, or if player is the only
          // non-bot player in the game.
          if (playerWon) {
            ReactGA.event({
              category: "Victory",
              action: playerID + " team won the game.",
            });
          } else {
            ReactGA.event({
              category: "Loss",
              action: playerID + " team lost the game.",
            });
          }

          this.queueSound(playerWon ? "victory" : "defeat");
          // Full-screen results (role reveal and how the game went) once the last animations have played.
          const showGameOver = () => {
            if (this.revealActive) {
              // Never in front of a reveal that is still playing.
              setTimeout(showGameOver, 300);
              return;
            }
            this.setState({ gameOverState: newState });
            this.onAnimationFinish();
          };
          this.addAnimationToQueue(showGameOver);
          this.gameOver = true;
          this.reconnectOnConnectionClosed = false;
          this.websocket?.close();
          break;

        default:
        // Do nothing
      }
    }

    if (announcesResult) {
      this.queueShownState(newState);
    }
  }

  /**
   * Adds an update of the board (players, phase, piles and the last government) to the animation queue.
   * @param newState the game state that the board should show from then on.
   * @effects When reached, sets {@code this.state.shownState} and advances the animation queue.
   */
  queueShownState(newState: GameState) {
    this.addAnimationToQueue(() => {
      this.setState({ shownState: newState });
      this.onAnimationFinish();
    });
  }

  //// Animation Handling
  // <editor-fold desc="Animation Handling">

  /**
   * Plays the next animation in the queue if it exists.
   * @effects If {@code this.animationQueue} is not empty,
   *          removes the function at the front of the animation queue and calls it.
   */
  onAnimationFinish() {
    if (this.animationQueue.length > 0) {
      let func = this.animationQueue.shift();
      if (func !== undefined) {
        func(); //call the function.
      }
    } else {
      // the animation queue is empty, so we set a flag.
      this.allAnimationsFinished = true;
      this.setState({ allAnimationsFinished: true });
    }
  }

  /**
   * Clears the animation queue and ends any currently playing animations.
   */
  clearAnimationQueue() {
    this.allAnimationsFinished = true;
    this.setState({ allAnimationsFinished: true });
    this.animationQueue = [];
  }

  /**
   * Adds the specified animation to the end of the queue.
   * @param func {function} the function to add to the animation queue.
   * @effects Adds the function to the back of the animation queue. If no animations are currently playing,
   *          starts the specified animation.
   */
  addAnimationToQueue(func: () => void) {
    this.animationQueue.push(func);
    if (this.allAnimationsFinished) {
      this.allAnimationsFinished = false;
      this.setState({ allAnimationsFinished: false });
      let func = this.animationQueue.shift();
      if (func !== undefined) {
        func(); //call the function.
      }
    }
  }

  showVotes(newState: GameState) {
    this.setState({
      statusBarText: "Tallying votes...",
      revealedVotes: newState.userVotes,
    });
    setTimeout(() => {
      this.setState({ showVotes: true });
    }, 1000);
    // Calculate final result:

    let noVotes = 0;
    let yesVotes = 0;
    Object.values(newState.userVotes).forEach((value) => {
      if (value) {
        yesVotes++;
      } else {
        noVotes++;
      }
    });
    setTimeout(() => {
      if (yesVotes > noVotes) {
        this.setState({
          statusBarText: yesVotes + " - " + noVotes + ": Vote passed",
        });
      } else {
        this.setState({
          statusBarText: yesVotes + " - " + noVotes + ": Vote failed",
        });
      }
    }, 2000);
    setTimeout(
      () =>
        this.setState({
          showVotes: false,
          statusBarText: "",
          revealedVotes: undefined,
        }),
      6000
    );
    setTimeout(() => {
      this.onAnimationFinish();
    }, 6500);
  }

  /**
   * Adds a listener to be called when the server returns an 'OK' status.
   * @param func The function to be called.
   * @effects adds the listener to the queue of functions. When the server returns an 'OK' status, all of the
   *          listeners will be called and then cleared from the queue.
   */
  addServerOKListener(func: () => void) {
    this.okMessageListeners.push(func);
  }

  /**
   * Hides the CustomAlert and marks this animation as finished.
   * @param delayExit {boolean} When true, delays advancing the animation queue until after the alert is hidden.
   * @effects: Sets {@code this.state.showAlert} to false and hides the CustomAlert.
   *           If delayExit is true, waits until the CustomAlert is done hiding before advancing the animation queue.
   *           Otherwise, immediately queues the next animation.
   */
  hideAlertAndFinish(delayExit = true) {
    this.setState({ showAlert: false });
    if (delayExit) {
      setTimeout(() => {
        this.setState({ alertContent: <div /> }); // reset the alert box contents
        this.onAnimationFinish();
      }, CUSTOM_ALERT_FADE_DURATION);
    } else {
      this.setState({ alertContent: <div /> });
      this.onAnimationFinish();
    }
  }

  /**
   * Shows the eventBar for a set period of time.
   * @param message {String} the message for the Event Bar to be fully visible.
   * @param duration {Number} the duration (in ms) for the Event Bar to be visible. (default is 3000 ms).
   * @effects Adds a function to the animation queue that, when called, shows the EventBar with the given message
   *          for {@code duration} ms, then advances to the next animation when finished.
   */
  queueEventUpdate(message: string, duration = 2000) {
    this.addAnimationToQueue(() => {
      this.setState({
        showEventBar: true,
        eventBarMessage: message,
      });
      setTimeout(() => {
        this.setState({ showEventBar: false });
      }, duration);
      setTimeout(() => {
        this.onAnimationFinish();
      }, duration + EVENT_BAR_FADE_OUT_DURATION);
    });
  }

  /**
   * Adds a CustomAlert to the animation queue.
   * @param content {html} the contents to be shown in the AlertBox.
   * @param closeOnOK {boolean} whether to close the alert when the server responds with an ok message. (default = true)
   * @param autoCloseWhenExecuted {boolean} whether the alert closes by itself on the screen of an executed player. (default = true)
   * @effects Adds a new function to the animation queue that, when called, causes a CustomAlert with the
   *          given {@code content} to appear. If {@code closeOnOK} is true, once shown, the alert box will
   *          be closed when the server responds with an 'ok' to any command. (There will be a short delay before the
   *          animation queue advances if not waiting for a server response.)
   */
  queueAlert(content: React.JSX.Element, closeOnOK = true, autoCloseWhenExecuted = true) {
    this.addAnimationToQueue(() => {
      this.setState({
        alertContent: content,
        showAlert: true,
      });
      if (this.userIsExecuted && autoCloseWhenExecuted) {
        // An executed player does not take part any more: the message closes by itself after a few seconds
        // instead of waiting for a click, so they do not hold up the animations of their own screen.
        setTimeout(() => {
          if (this.state.showAlert && this.state.alertContent === content) {
            this.hideAlertAndFinish();
          }
        }, EXECUTED_ALERT_DURATION);
      }
      if (closeOnOK && !this.userIsExecuted) {
        // Remove the exit delay if waiting for the server response, because otherwise the player will lag
        // behind everyone else.
        this.addServerOKListener(() => {
          if (!this.revealActive) {
            this.hideAlertAndFinish(false);
          }
        });
      }
    });
  }

  /**
   * Adds a sound effect to the animation queue, so that it plays in sync with the alerts around it.
   * @param name {SoundName} the sound to play. Does nothing if sound is turned off.
   * @effects Plays the sound when reached, then instantly advances the animation queue.
   */
  queueSound(name: SoundName) {
    this.addAnimationToQueue(() => {
      playSound(name);
      this.onAnimationFinish();
    });
  }

  /**
   * Adds an update to the status message to the animation queue.
   * @param message {String} the text for the status bar to display.
   * @effects Adds a new function to the animation queue that, when called, updates {@code this.state.statusBarText} to
   *          the message provided then instantly advances the animation queue.
   */
  queueStatusMessage(message: string) {
    this.addAnimationToQueue(() => {
      this.setState({ statusBarText: message });
      this.onAnimationFinish();
    });
  }

  // </editor-fold>

  /**
   * Renders the game page.
   */
  renderGamePage() {
    // The board shows the delayed state, so it never runs ahead of the animations.
    const gameState = this.state.shownState;
    // The Fascists can win by electing Hitler once three Fascist policies are in, so nominating and
    // voting are the dangerous phases.
    const hitlerZoneActive =
      this.state.fascistPolicies >= 3 &&
      (gameState.state === LobbyState.CHANCELLOR_NOMINATION ||
        gameState.state === LobbyState.CHANCELLOR_VOTING);
    const endTermReady =
      gameState[PARAM_STATE] === STATE_POST_LEGISLATIVE &&
      this.state.name === gameState[PARAM_PRESIDENT];
    const playerCount = gameState.playerOrder.length;
    const fascistCount = playerCount <= 6 ? 1 : playerCount <= 8 ? 2 : 3;
    const tracker = this.state.electionTracker;
    const lastGovernment = lastGovernmentSentence(gameState.history);
    const round = isRoundTable();

    return (
      <div className={"ga-page" + (round ? " gb-page" : "")}>
        <CustomAlert show={this.state.showAlert}>
          {this.state.alertContent}
        </CustomAlert>

        <EventBar
          show={this.state.showEventBar}
          message={this.state.eventBarMessage}
        />

        <HitlerZoneVignette active={hitlerZoneActive} />

        {this.state.gameOverState && (
          <GameOverScreen
            gameState={this.state.gameOverState}
            user={this.state.name}
            onBackToLobby={() => this.returnToLobby()}
            onLeave={() => this.leaveAfterGame()}
          />
        )}

        {round ? (
          <div className="ga-inner gb-inner">
            <div className="ga-topbar">
              <div className="ga-logo">SECRET HITLER</div>
              <div className="ga-status">
                <div className="ga-phase">
                  {gameState.round ? "Round " + gameState.round + " · " : ""}
                  {this.getPhaseName()}
                </div>
              </div>
              <div className="game-chips">
                {gameState.testMode && (
                  <span className="game-chip test-mode">
                    TEST MODE: all roles visible
                  </span>
                )}
                <button
                  className="game-chip"
                  aria-pressed={isSoundEnabled()}
                  onClick={() => {
                    setSoundEnabled(!isSoundEnabled());
                    this.forceUpdate();
                  }}
                >
                  {isSoundEnabled() ? "SOUND ON" : "SOUND OFF"}
                </button>
                {hasVoteHistory(gameState) && (
                  <button className="game-chip" onClick={() => this.setState({ showVoteHistory: true })}>
                    VOTES
                  </button>
                )}
                <button
                  className={"game-chip" + (this.state.showTips ? " game-chip-on" : "")}
                  aria-pressed={this.state.showTips}
                  onClick={this.toggleTips}
                >
                  TIPS
                </button>
                <button className="game-chip" onClick={() => this.setState({ showRules: true })}>
                  RULES
                </button>
                <LayoutMenu variant="chip" onChange={this.switchLayout} />
                <ThemeMenu variant="chip" />
                {(gameState.kickable?.length ?? 0) > 0 && (
                  <button className="game-chip" onClick={() => this.setState({ showKickList: true })}>
                    REMOVE PLAYER
                  </button>
                )}
                {this.renderKickDialogs(true, gameState.kickable ?? [], gameState.icon)}
                {this.state.showVoteHistory && !this.state.gameOverState && (
                  <VoteHistoryDialog
                    gameState={gameState}
                    user={this.state.name}
                    onClose={() => this.setState({ showVoteHistory: false })}
                  />
                )}
                {this.state.showRules && !this.state.gameOverState && (
                  <RulesSheet gameState={gameState} onClose={() => this.setState({ showRules: false })} />
                )}
                {this.state.showTips && !this.state.gameOverState && (
                  <TipsPanel gameState={gameState} user={this.state.name} onClose={this.toggleTips} />
                )}
              </div>
            </div>

            <div className="gb-stage">
              <PlayerCards
                user={this.state.name}
                gameState={gameState}
                showVotes={this.state.showVotes}
                votes={this.state.revealedVotes}
                showBusy={this.state.allAnimationsFinished}
                layout="round"
              />
              <div className={"gb-table" + (hitlerZoneActive ? " gb-zone" : "")}>
                {hitlerZoneActive && (
                  <div className="gb-zone-pill">
                    Hitler zone ·{" "}
                    {gameState.state === LobbyState.CHANCELLOR_VOTING ? "vote" : "elect"} with care
                  </div>
                )}
                <div className="gb-board">
                  <Pile label="Draw pile" count={gameState.drawSize} kind="draw" />
                  <PolicyTrack
                    numLiberalPolicies={this.state.liberalPolicies}
                    numFascistPolicies={this.state.fascistPolicies}
                    playerCount={playerCount}
                    hitlerZone={hitlerZoneActive}
                  />
                  <Pile label="Discard pile" count={gameState.discardSize} kind="discard" />
                </div>
                <div
                  className="ga-tracker gb-tracker"
                  title="Three failed elections in a row enact the top policy"
                >
                  <span>Election tracker</span>
                  {[0, 1, 2].map((i) => (
                    <span
                      key={i}
                      className={
                        "ga-dot" +
                        (i < tracker ? " on" : "") +
                        (i === 2 && tracker === 2 ? " danger" : "")
                      }
                    />
                  ))}
                </div>
                <div className="gb-action">
                  <MainPanel
                    user={this.state.name}
                    gameState={gameState}
                    statusText={this.state.statusBarText}
                    endTermReady={endTermReady}
                    alertOpen={this.state.showAlert}
                    onEndTerm={() => {
                      this.sendWSCommand({ command: WSCommandType.END_TERM });
                    }}
                  />
                </div>
                <div className="gb-roster">
                  {playerCount} players: {playerCount - fascistCount - 1} Liberals, {fascistCount}{" "}
                  Fascist{fascistCount > 1 ? "s" : ""} and Hitler.
                  {lastGovernment && (
                    <div className="gb-last-government">Last government: {lastGovernment}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
        <div className="ga-inner">
          <div className="ga-topbar">
            <div className="ga-logo">SECRET HITLER</div>
            <div className="ga-status">
              <div className="ga-phase">
                {gameState.round ? "Round " + gameState.round + " · " : ""}
                {this.getPhaseName()}
              </div>
              <div
                className="ga-tracker"
                title="Three failed elections in a row enact the top policy"
              >
                <span>Election tracker</span>
                {[0, 1, 2].map((i) => (
                  <span
                    key={i}
                    className={
                      "ga-dot" +
                      (i < tracker ? " on" : "") +
                      (i === 2 && tracker === 2 ? " danger" : "")
                    }
                  />
                ))}
              </div>
            </div>
            <div className="game-chips">
              {gameState.testMode && (
                <span className="game-chip test-mode">
                  TEST MODE: all roles visible
                </span>
              )}
              <button
                className="game-chip"
                aria-pressed={isSoundEnabled()}
                onClick={() => {
                  setSoundEnabled(!isSoundEnabled());
                  this.forceUpdate();
                }}
              >
                {isSoundEnabled() ? "SOUND ON" : "SOUND OFF"}
              </button>
              {hasVoteHistory(gameState) && (
                <button className="game-chip" onClick={() => this.setState({ showVoteHistory: true })}>
                  VOTES
                </button>
              )}
              <button
                className={"game-chip" + (this.state.showTips ? " game-chip-on" : "")}
                aria-pressed={this.state.showTips}
                onClick={this.toggleTips}
              >
                TIPS
              </button>
              <button className="game-chip" onClick={() => this.setState({ showRules: true })}>
                RULES
              </button>
              <LayoutMenu variant="chip" onChange={this.switchLayout} />
              <ThemeMenu variant="chip" />
              {(gameState.kickable?.length ?? 0) > 0 && (
                <button className="game-chip" onClick={() => this.setState({ showKickList: true })}>
                  REMOVE PLAYER
                </button>
              )}
              {this.renderKickDialogs(true, gameState.kickable ?? [], gameState.icon)}
              {this.state.showVoteHistory && !this.state.gameOverState && (
                <VoteHistoryDialog
                  gameState={gameState}
                  user={this.state.name}
                  onClose={() => this.setState({ showVoteHistory: false })}
                />
              )}
              {this.state.showRules && !this.state.gameOverState && (
                <RulesSheet gameState={gameState} onClose={() => this.setState({ showRules: false })} />
              )}
              {this.state.showTips && !this.state.gameOverState && (
                <TipsPanel gameState={gameState} user={this.state.name} onClose={this.toggleTips} />
              )}
            </div>
          </div>

          {hitlerZoneActive && (
            <HitlerZoneWarning
              pill={
                gameState.state === LobbyState.CHANCELLOR_VOTING
                  ? "Vote with care"
                  : "Nominate with care"
              }
            >
              Three Fascist policies are in. If Hitler is elected Chancellor,
              the Fascists win on the spot.
            </HitlerZoneWarning>
          )}

          <PlayerCards
            user={this.state.name}
            gameState={gameState}
            showVotes={this.state.showVotes}
            votes={this.state.revealedVotes}
            showBusy={this.state.allAnimationsFinished}
          />

          <div className="ga-columns">
            <div className="ga-left">
              <PolicyTrack
                numLiberalPolicies={this.state.liberalPolicies}
                numFascistPolicies={this.state.fascistPolicies}
                playerCount={playerCount}
                hitlerZone={hitlerZoneActive}
              />
              <div className="ga-below">
                <DeckPiles
                  drawSize={gameState.drawSize}
                  discardSize={gameState.discardSize}
                />
                <div className="ga-roster">
                  {playerCount} players: {playerCount - fascistCount - 1}{" "}
                  Liberals, {fascistCount} Fascist{fascistCount > 1 ? "s" : ""}{" "}
                  and Hitler.
                </div>
              </div>
            </div>

            <div className="ga-right">
              <ActionPanel
                user={this.state.name}
                gameState={gameState}
                statusText={this.state.statusBarText}
                endTermReady={endTermReady}
                alertOpen={this.state.showAlert}
                onEndTerm={() => {
                  this.sendWSCommand({ command: WSCommandType.END_TERM });
                }}
              />
              {lastGovernment && (
                <div className="ap-panel ap-last">
                  <div className="ap-kicker ap-kicker-muted">Last government</div>
                  <div className="ap-text">{lastGovernment}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        )}

        <div className="snackbar-host">
          <div id="snackbar">{this.state.snackbarMessage}</div>
        </div>
      </div>
    );
  }

  /** Reconnects to the same lobby after a game, ready for another round. */
  returnToLobby() {
    this.gameOver = false;
    this.reconnectOnConnectionClosed = true;
    this.clearAnimationQueue();
    this.tryOpenWebSocket(this.state.name, this.state.lobby);
    this.setState({
      page: PAGE.LOBBY,
      showAlert: false,
      showVoteHistory: false,
      showRules: false,
      showKickList: false,
      kickTarget: undefined,
      gameOverState: undefined,
      gameState: DEFAULT_GAME_STATE,
      shownState: DEFAULT_GAME_STATE,
      revealedVotes: undefined,
      showVotes: false,
      liberalPolicies: 0,
      fascistPolicies: 0,
      electionTracker: 0,
    });
  }

  /** Leaves after a game: back to the start page. */
  leaveAfterGame() {
    this.gameOver = false;
    this.clearAnimationQueue();
    this.setState({
      page: PAGE.LOGIN,
      showAlert: false,
      showVoteHistory: false,
      showRules: false,
      showKickList: false,
      kickTarget: undefined,
      gameOverState: undefined,
      gameState: DEFAULT_GAME_STATE,
      shownState: DEFAULT_GAME_STATE,
      revealedVotes: undefined,
      showVotes: false,
      joinName: this.state.name,
      joinLobby: this.state.lobby,
      joinError: "",
    });
  }

  /** Short name of the current phase, shown in the status row. */
  getPhaseName(): string {
    switch (this.state.shownState.state) {
      case LobbyState.CHANCELLOR_NOMINATION:
        return "Nomination";
      case LobbyState.CHANCELLOR_VOTING:
        return "Election";
      case LobbyState.LEGISLATIVE_PRESIDENT:
      case LobbyState.LEGISLATIVE_CHANCELLOR:
      case LobbyState.LEGISLATIVE_PRESIDENT_VETO:
        return "Legislative session";
      case LobbyState.PP_PEEK:
      case LobbyState.PP_INVESTIGATE:
      case LobbyState.PP_EXECUTION:
      case LobbyState.PP_ELECTION:
        return "Presidential power";
      case LobbyState.POST_LEGISLATIVE:
        return "End of term";
      case LobbyState.SETUP:
        return "Setting up";
      default:
        return "Game over";
    }
  }

  //</editor-fold>

  render() {
    // Check URL params. If joining from a lobby link, open the lobby with the given code.
    let url = window.location.search;
    let lobby = new URLSearchParams(url).get("lobby");
    if (lobby !== null && !this.state.lobbyFromURL) {
      ReactGA.event({
        category: "Lobby Link",
        action: "User is using a lobby link.",
      });
      this.setState({
        joinLobby: lobby.toUpperCase().substr(0, 4),
        lobbyFromURL: true,
      });
    }

    let page_render;
    switch (this.state.page) {
      case PAGE.LOBBY:
        page_render = this.renderLobbyPage();
        break;
      case PAGE.GAME:
        page_render = this.renderGamePage();
        break;
      case PAGE.LOGIN: // login is default
      default:
        page_render = this.renderLoginPage();
    }
    return (
      <>
        <HelmetMetaData />
        {page_render}
      </>
    );
  }
}

export default App;
